import type { TenantBillingConfigurationView } from '@klareospace/pharos-lib-types';

import { computeFreeTrialBannerState } from './free-trial-banner-state';

// ─── Types ────────────────────────────────────────────────────────────────────

export const BILLING_PAGE_STATE = {
  CURRENT_PLAN: 'current_plan',
  NO_ACTIVE_PLAN: 'no_active_plan',
  ON_FREE_TRIAL: 'on_free_trial',
} as const;
export type BillingPageState = (typeof BILLING_PAGE_STATE)[keyof typeof BILLING_PAGE_STATE];

// ─── Util ─────────────────────────────────────────────────────────────────────

/**
 * Derives the settings billing page's display state: a chosen plan, a started and still-running
 * trial, or the neutral "no active plan" state (no configuration, scheduled, expired, or revoked trial).
 */
export function resolveBillingPageState(
  view: TenantBillingConfigurationView | null | undefined,
  todayUtc: Date,
): BillingPageState {
  if (view?.plan) {
    return BILLING_PAGE_STATE.CURRENT_PLAN;
  }

  const { visible } = computeFreeTrialBannerState(view, todayUtc);
  return visible ? BILLING_PAGE_STATE.ON_FREE_TRIAL : BILLING_PAGE_STATE.NO_ACTIVE_PLAN;
}
